import {
  AppstoreOutlined,
  BellOutlined,
  FileTextOutlined,
  LogoutOutlined,
  SwapOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Button, Layout, Menu } from "antd";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../redux/slices/authSlice";
import { AppDispatch } from "../redux/store";

const { Sider } = Layout;

export function AdminSidebar() {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  // highlight current menu item
  const selectedKey = (() => {
    const p = location.pathname;

    if (p.startsWith("/packages")) return "packages";
    if (p.startsWith("/admin/transactions")) return "admin-transactions";
    if (p.startsWith("/admin/notifications")) return "admin-notifications";
    if (p.startsWith("/admin/reseller-leads")) return "admin-reseller-leads";
    if (p.startsWith("/resellers")) return "resellers";

    return "resellers";
  })();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const menuItems = [
    {
      key: "resellers",
      icon: <TeamOutlined />,
      label: <Link to="/resellers">Resellers</Link>,
    },
    {
      key: "packages",
      icon: <AppstoreOutlined />,
      label: <Link to="/packages">Packages</Link>,
    },
    {
      key: "admin-transactions",
      icon: <SwapOutlined />,
      label: <Link to="/admin/transactions">Transactions</Link>,
    },
    {
      key: "admin-notifications",
      icon: <BellOutlined />,
      label: <Link to="/admin/notifications">Notifications</Link>,
    },
    {
      key: "admin-reseller-leads",
      icon: <FileTextOutlined />,
      label: <Link to="/admin/reseller-leads">Reseller Leads</Link>,
    },
  ];

  return (
    <Sider width={240} className="side-nav">
      <div className="side-nav__content">
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          className="side-nav__menu"
          items={menuItems}
        />
        <div className="side-nav__logout">
          <Button
            type="text"
            danger
            icon={<LogoutOutlined />}
            onClick={handleLogout}
            className="side-nav__logout-button"
          >
            Logout
          </Button>
        </div>
      </div>
    </Sider>
  );
}
